import { render, staticRenderFns } from "./ContactsMainSection.vue?vue&type=template&id=270b2592&scoped=true&"
import script from "./ContactsMainSection.vue?vue&type=script&lang=js&"
export * from "./ContactsMainSection.vue?vue&type=script&lang=js&"
import style0 from "./ContactsMainSection.vue?vue&type=style&index=0&id=270b2592&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270b2592",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
